export class IndividualCivilStatusTypeReferenceModel {
    public individualCivilStatusTypeCode: string;
    public individualCivilStatusTypeName: string;
    public sortSequence: number;
}